const ANCILLARY_OFFER_TYPES = {
  ANCILLARY: 'AncillaryOffer',
  BAGGAGE_ANCILLARY: 'BaggageAncillaryOffer',
  BAGGAGE_LIGHT_ANCILLARY: 'BaggageLightAncillaryOffer',
  SEAT_ANCILLARY: 'SeatUpgradeAncillaryOffer',
  CARRY_ON_OFFER: 'BaggageAncillaryOffer',
};

export default ANCILLARY_OFFER_TYPES;
